import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('admin-reports-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider.state('retailerReports-admin', {
      parent: 'arw',
      url: '/admin-reports',
      template: '<admin-reports-page></admin-reports-page>',
      redirectTo: 'permissions-denied',
      params: {
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Site Activity Log')));
          },
        ],
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/admin-reports/admin-reports-routing-module.js